/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Status of the template
 */
export type TemplateStatus =
  (typeof TemplateStatus)[keyof typeof TemplateStatus];

export const TemplateStatus = {
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed",
} as const;
